import React from "react";
import { motion } from "framer-motion";

import DoctorInfo from "../../HomeSections/DoctorInfo";
import TestimonialCarousel from "../../HomeSections/TestimonialCarousel";
import CounterCard from "../../HomeSections/CounterCard";
import OurDoctors from "../../HomeSections/OurDoctors";
import ContactUs from "../../HomeSections/ContactUS";
import BlogsSection from "../../HomeSections/BlogsSection";
import { useDoctorQuery } from "../../../hooks/useDoctorQuery";
import PackagePurchase from "../../HomeSections/Packages";
import LockedDoctor from "../../HomeSections/LockedDoctor";
import NewsSection from "../../HomeSections/OurNews";
import OurServices from "../../HomeSections/OurServices";

export default function Home() {
  const sectionVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };
  
  return (
    <div className="space-y-16">
      <motion.div   variants={sectionVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }}>
                <CounterCard />
            </motion.div>
      <motion.div
        id="doctor"
        variants={sectionVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <DoctorInfo />
      </motion.div>
      <motion.div
        id="team"
        variants={sectionVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <OurDoctors />
      </motion.div>
      <motion.div
        variants={sectionVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <OurServices />
      </motion.div>

      <motion.div
        id="news" 
       
        variants={sectionVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <NewsSection />
      </motion.div>
      <motion.div
        
        variants={sectionVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <BlogsSection />
      </motion.div>
      <motion.div
        id="packages"
        variants={sectionVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <PackagePurchase />
      </motion.div>


      <motion.div
        id="reviews"
        variants={sectionVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <TestimonialCarousel />
      </motion.div>
      <motion.div
        id="contact"
        variants={sectionVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <ContactUs />
      </motion.div>
    </div>
  );
}
